import React, { Fragment, useEffect, useRef, useState } from 'react';
import Helmet from 'react-helmet';
import moment from 'moment';
import _ from 'lodash';
import { QRCodeSVG } from 'qrcode.react';
import { Box, Grid, Stack } from '@mui/material';
import { SEARCH_PARAMS_SESSION_PAGE } from '@bld/bld-libs/constants';
import { initSearchParamsSession } from '@bld/bld-libs/utils';
import Tippy from '../components/ReactTippy';
import {
  FILE_CODE,
  HEADER_CONSTANTS,
  JAPANESE_EMPTY_STRING,
  KY_STATUS_CONFIG,
  PRIVATE_PARTNER_COMPANY_LABEL,
  REQUEST_PARAMS,
  STATUS_CODE,
} from '../utilities/constants';
import { messageUtility } from '../utilities/messageUtility';
import EventManager, { EventType } from '../utilities/EventManager';
import { fetchFieldServiceInfo } from '../utilities/dateSelectorUtility';
import { CompanyBranchService } from '../services/CompanyBranches';
import sessionStorageService from '../services/utilities/SessionStorageService';
import KYReportsService from '../services/KYReportsService';
import { FieldTreeService } from '../services/FieldTrees';
import PrintService from '../services/Prints';
import { ConferencePageHeader } from '../components/PageHeader';
import InfinityScrollLoad from '../components/InfinityScrollLoad';
import {
  KyReportSearchForm,
  KyReportSearchFormDetail,
  LIST_KY_WORK_FINISH_REPORT_SEARCH_STATUS,
} from '../components/searchmenus/ListKyReportSearch';
import { Confirmation, Information } from '../components/modals/common';
import { DetailKYReport } from '../components/DetailKYReport';
import {
  hasRejectApprovalConflict,
  isPermissionError,
} from '../utilities/apiErrorMessage';
import { FormInformationDialog } from '../components/FormInformationDialog';
import _dialogLoader from '../utilities/dialogLoader';
import KyReportUtility from '../utilities/kyReportUtil';
import ReportNames from '../utilities/reportNames';
import PrintUtility from '../utilities/printUtility';
import { isKYTemporarySaveError } from '../utilities/apiErrorMessage';
import { CancelAndConfirmDialog } from '../components/modals/CancelAndConfirmDialog';
import { truncateTextNameConcatSuffix } from '../utilities/commonUtil';
import { isPrimaryCompanyRoleId } from '../utilities/roleUtility';

const TABLE_TITLE = {
  WORK_DATE: '日付',
  STATUS: 'ステータス',
  COMPANY_NAME_1: '一次協力会社',
  JOB_DESCRIPTION: '職種/作業内容',
  MANAGER_USER_NAME: '元請担当者',
  REVIEW_CONTRACTOR_USER_NAME: '元請確認者',
};
const defaultSearchParams = {
  work_date: null,
  work_hour_zone: null,
  field_trees: [],
  manager_users: [],
  status: LIST_KY_WORK_FINISH_REPORT_SEARCH_STATUS.NOT_CONFIRM.ID,
};

export class FieldListKY extends React.Component {
  constructor(props) {
    super(props);
    let params = _.cloneDeep(defaultSearchParams);
    this.SessionSearch = initSearchParamsSession(
      SEARCH_PARAMS_SESSION_PAGE.KY_REPORT
    );
    const savedParams = this.SessionSearch.get();
    if (!_.isEmpty(savedParams)) {
      params = { ...params, ...savedParams };
    }

    this.state = {
      fieldId: sessionStorageService.getFieldId(),
      timeZoneInfo: {},
      data: [],
      total: 0,
      isLoading: true,
      allLoaded: false, // ページング用ロードフラグ
      params, // 検索条件
      tempParams: _.cloneDeep(params), // 検索条件(保管用)
      tempParamsModal: _.cloneDeep(params),
      isCheckedAll: false,
      selectedList: [],
      kyReportId: null,
      kyReportData: {},
      listFieldTree: [],
      isDetailKYOpen: false,
      isShowConfirmDialog: false,
      isDetailSearchFormOpen: false,
      bulkComment: '',
      companyBranchId: null,
      warning_threshold: null,
      exportResultDialog: {},
      isShowChooseExportTypeDialog: false,
      keyRerenderSearchDetail: 0,
    };
    this.events = {
      searchForm: {
        showDetail: this.handleOpenSearchFormDetail,
        closeDetail: this.handleCloseSearchFormDetail,
        searchExecutionDetail: this.searchExecutionDetail,
        changeParamData: this.handleChangeParamData,
        clearParamsSearch: this.clearParamsSearch,
        clearTempParamsModal: this.clearTempParamsModal,
        searchExecution: this.searchExecution,
      },
      table: {
        checkOrUncheckRow: this.handleCheckOrUncheckRow,
        checkOrUncheckAll: this.handleCheckOrUncheckAll,
        clickRowKY: this.handleClickRowKY,
        loadMore: notifyEnd => this.fetchFieldListKY(notifyEnd),
      },
      detailKY: {
        handleCloseDetailKY: this.handleCloseDetailKY,
        handleUpdateStatus: this.handleUpdateStatus,
      },
      confirmDialog: {
        open: this.handleOpenConfirmDialog,
        close: this.handleCloseConfirmDialog,
        submit: this.bulkUpdateStatus,
      },
    };
    this.searchButtonRef = React.createRef(); // 検索ボタン要素
    this.isSubmittingFlag = false;
    this.isNavigatingFlag = false;
    this.isExportingFlag = false;
    this.clearFlag = false;
    this.needReloadData = false;
  }

  componentDidUpdate() {
    if (this.clearFlag === true) {
      this.clearFlag = false;
    }
  }

  fetchFieldListKY = notify => {
    if (this.state.allLoaded && notify) {
      notify();
      return;
    }
    this.setState({ isLoading: true });
    const {
      fieldId,
      params,
      data,
      total,
      selectedList,
      isCheckedAll,
    } = this.state;
    this.SessionSearch.set(params);
    const searchParams = {
      ..._.omit(params, ['field_trees', 'manager_users']),
      field_tree_id_1s: _.map(params.field_trees, 'id'),
      manager_user_ids: _.map(params.manager_users, 'user_id'),
      offset: notify ? _.size(data) : 0,
      limit: REQUEST_PARAMS.parentLimit,
    };
    KYReportsService.list(fieldId, searchParams)
      .then(res => {
        if (_.get(res, 'result')) {
          const newReports = _.get(res, 'data.entities.ky_reports');
          if (_.isEmpty(newReports)) {
            this.setState({
              allLoaded: true,
              data: notify ? data : [],
              total: notify ? total : 0,
              selectedList: notify ? selectedList : [],
              isCheckedAll: notify ? isCheckedAll : false,
            });
          } else {
            const newData = _.concat(notify ? data : [], newReports);
            this.setState({
              data: newData,
              total: _.get(res, 'data.total'),
              allLoaded: false,
              selectedList: notify ? selectedList : [],
              isCheckedAll: false,
            });
          }
        } else {
          this.handleError(res);
        }
      })
      .finally(() => {
        if (notify) {
          notify();
        }
        this.setState({ isLoading: false });
        this.searchButtonRef.current.disabled = false;
      });
  };

  handleGetAllDataTable = async () => {
    this.needReloadData = false;
    const { fieldId, params, total } = this.state;
    const response = await KYReportsService.list(fieldId, {
      ..._.omit(params, ['field_trees', 'manager_users']),
      field_tree_id_1s: _.map(params.field_trees, 'id'),
      manager_user_ids: _.map(params.manager_users, 'user_id'),
      offset: 0,
      limit: total,
    });
    if (response.result) {
      const resData = response.data.entities.ky_reports;
      this.setState({
        allLoaded: true,
        data: resData,
        total: response.data.total,
      });
      return resData;
    } else {
      this.handleError(response);
    }
    return [];
  };

  handleError = response => {
    const message = _.get(response, 'data.message');
    if (isPermissionError(message)) {
      _dialogLoader.show(FormInformationDialog, {
        title: messageUtility.getMessage('E-001-464'),
        message: messageUtility.getMessage('E-001-465'),
        buttonText: messageUtility.getMessage('I-000-017'),
        onClose: this.handleCloseErrorPermissionDialog,
      });
    } else if (isKYTemporarySaveError(message)) {
      _dialogLoader.show(FormInformationDialog, {
        title: messageUtility.getMessage('E-001-402'),
        message: messageUtility.getMessage('E-001-469'),
        onClose: this.handleCloseKYTemporarySaveError,
      });
    } else if (hasRejectApprovalConflict(message)) {
      _dialogLoader.show(CancelAndConfirmDialog, {
        title: messageUtility.getMessage('E-001-402'),
        message: messageUtility.getMessage('E-001-470'),
        confirmButtonText: messageUtility.getMessage('I-000-180'),
        cancelButtonText: messageUtility.getMessage('I-000-017'),
        onCancel: () => {
          this.needReloadData = true;
          _dialogLoader.close();
        },
        onConfirm: this.handleConfirmRejectApprovalConflict,
      });
    } else if (_.get(response, 'status') === STATUS_CODE.forbidden) {
      window.location.replace('/error-permission');
    }
  };

  handleCloseErrorPermissionDialog = () => {
    _dialogLoader.close();
    window.location.replace('/error-permission');
    this.setState({
      allLoaded: true,
      listWorkFinishReports: [],
      total: 0,
      listReportSelected: [],
      isCheckedAll: false,
    });
  };

  handleConfirmRejectApprovalConflict = () => {
    this.needReloadData = true;
    this.handleFetchDetailKYReport();
    _dialogLoader.close();
  };

  handleCloseKYTemporarySaveError = () => {
    this.needReloadData = true;
    _dialogLoader.close();
  }

  handleFetchTimeZoneInfo = async () => {
    const timeZoneInfo = await fetchFieldServiceInfo(
      this.state.fieldId,
      sessionStorageService.getWorkHourZone(),
      true
    );
    this.setState({
      timeZoneInfo: _.omit(timeZoneInfo, 'fieldInfo'),
      companyBranchId: _.get(
        timeZoneInfo,
        'fieldInfo.company.company_branch_id'
      ),
    });
  };

  handleFetchListFieldTrees = async () => {
    const response = await FieldTreeService.levelList(this.state.fieldId);
    const listFieldTree = _.get(response, 'data.entities.field_trees', []);
    _.forEach(listFieldTree, fieldTree => {
      if (fieldTree.private_partner_company_flag) {
        fieldTree.company_name = fieldTree.company_name.concat(
          PRIVATE_PARTNER_COMPANY_LABEL
        );
      }
    });
    this.setState({
      listFieldTree: _.get(response, 'data.entities.field_trees', []),
    });
  };

  componentDidMount() {
    if (isPrimaryCompanyRoleId()) {
      EventManager.trigger(EventType.ACCESS_KY_REPORT_WORK_PAGE);
      this.fetchFieldListKY();
      this.handleFetchTimeZoneInfo();
      this.handleFetchListFieldTrees();
    } else {
      window.location.replace('/error-permission');
    }
  }

  componentWillUnmount() {
    EventManager.trigger(EventType.ACCESS_KY_REPORT_WORK_PAGE);
  }

  bulkUpdateStatus = comment => {
    if (this.isSubmittingFlag) {
      return;
    }
    this.isSubmittingFlag = true;

    const { fieldId, selectedList } = this.state;
    const params = {
      ky_report_ids: selectedList,
      comment,
    };
    KYReportsService.bulkUpdateStatus(fieldId, params)
      .then(res => {
        if (_.get(res, 'result')) {
          this.fetchFieldListKY();
        }
      })
      .finally(() => {
        this.handleCloseConfirmDialog();
        this.isSubmittingFlag = false;
      });
  };

  handleUpdateStatus = async params => {
    const { fieldId, kyReportId } = this.state;
    const response = await KYReportsService.updateStatus(
      fieldId,
      kyReportId,
      params
    );
    if (response.result) {
      this.needReloadData = true;
      this.doNavigateDetailKY(kyReportId);
    } else {
      this.handleError(response);
    }
  };

  handleGetDataSetting = () => {
    CompanyBranchService.getKYRiskAssessmentSettings(
      this.state.companyBranchId
    ).then(response => {
      if (response.result) {
        this.setState({
          warning_threshold: _.get(
            response,
            'data.entities.ky_assessment_result_settings.warning_threshold',
            null
          ),
        });
      }
    });
  };

  handleFetchDetailKYReport = async () => {
    await this.handleGetDataSetting();
    const { fieldId, kyReportId } = this.state;
    KYReportsService.detail(fieldId, kyReportId).then(res => {
      if (_.get(res, 'result')) {
        this.setState({
          kyReportData: _.get(res, 'data.entities.ky_report'),
        });
      }
    });
  };

  performNavigate = isNext => {
    if (this.isNavigatingFlag) return;
    this.isNavigatingFlag = true;
    const { data, kyReportId } = this.state;
    KyReportUtility.handleNavigate(
      data,
      kyReportId,
      this.doNavigateDetailKY,
      this.handleCloseDetailKY,
      this.handleGetAllDataTable,
      isNext
    ).then(() => {
      this.isNavigatingFlag = false;
    });
  };

  doNavigateDetailKY = id => {
    this.setState(
      { kyReportId: id, kyReportData: {} },
      this.handleFetchDetailKYReport
    );
  };

  handleCloseDetailKY = () => {
    this.setState({
      isDetailKYOpen: false,
      kyReportId: null,
      kyReportData: {},
    });
    EventManager.trigger(EventType.LAYOUT_UPDATE, {});
    if (this.needReloadData) {
      this.fetchFieldListKY();
      this.needReloadData = false;
    }
  };

  handleCloseSearchFormDetail = () => {
    this.setState({ isDetailSearchFormOpen: false });
  };

  handleCloseConfirmDialog = () => {
    this.setState({ isShowConfirmDialog: false, bulkComment: '' });
  };

  handleOpenConfirmDialog = () => {
    this.setState({ isShowConfirmDialog: true });
  };

  handleOpenSearchFormDetail = () => {
    const tempParamsModal = _.cloneDeep(this.state.tempParams);
    this.setState({ isDetailSearchFormOpen: true, tempParamsModal });
  };

  handleClickRowKY = async id => {
    this.setState(
      {
        isDetailKYOpen: true,
        kyReportId: id,
        kyReportData: {},
        selectedList: [],
        isCheckedAll: false,
      },
      this.handleFetchDetailKYReport
    );
  };

  handleChangeParamData = (name, values, stateName) => {
    const newParams = _.cloneDeep(this.state[stateName]);
    newParams[name] = values;
    this.setState({ [stateName]: newParams });
  };

  handleCheckOrUncheckAll = e => {
    const { checked } = e.target;
    const selectedList = checked ? _.map(this.state.data, 'id') : [];
    this.setState({ selectedList, isCheckedAll: checked });
  };

  handleCheckOrUncheckRow = (e, id) => {
    e.stopPropagation();
    const { checked } = e.target;
    const { selectedList, data } = this.state;
    const newSelectedList = checked
      ? [...selectedList, id]
      : _.filter(selectedList, selectedId => selectedId !== id);
    this.setState({
      selectedList: newSelectedList,
      isCheckedAll: _.size(newSelectedList) === _.size(data),
    });
  };

  searchExecution = () => {
    const params = _.cloneDeep(this.state.tempParams);
    this.setState({ params, isDetailSearchFormOpen: false, data: [] }, () => {
      this.fetchFieldListKY();
    });
  };

  searchExecutionDetail = () => {
    this.searchButtonRef.current.disabled = true;
    const tempParams = _.cloneDeep(this.state.tempParamsModal);
    const currentParams = this.state.params;
    const params = _.cloneDeep({ ...currentParams, ...tempParams });

    this.setState(
      {
        params,
        tempParams,
        isDetailSearchFormOpen: false,
        data: [],
      },
      () => {
        this.fetchFieldListKY();
      }
    );
  };

  clearParamsSearch = () => {
    this.clearFlag = true;
    this.setState(
      {
        params: _.cloneDeep(defaultSearchParams),
        tempParams: _.cloneDeep(defaultSearchParams),
        tempParamsModal: _.cloneDeep(defaultSearchParams),
        data: [],
      },
      () => {
        this.fetchFieldListKY();
      }
    );
  };

  clearTempParamsModal = () => {
    this.setState(prev => ({
      tempParamsModal: _.cloneDeep(defaultSearchParams),
      keyRerenderSearchDetail: prev.keyRerenderSearchDetail + 1,
    }));
  };

  handleClickExportReport = () => {
    const { isDetailKYOpen, kyReportId, selectedList } = this.state;
    const listIds = isDetailKYOpen ? [kyReportId] : selectedList;
    if (_.isEmpty(listIds)) {
      return;
    } else if (listIds.length > 100) {
      _dialogLoader.show(FormInformationDialog, {
        title: messageUtility.getMessage('E-001-467'),
        message: messageUtility.getMessage('E-001-468', String(listIds.length)),
        buttonText: messageUtility.getMessage('I-000-017'),
        onClose: () => {
          _dialogLoader.close();
        },
      });
      return;
    }
    this.setState({ isShowChooseExportTypeDialog: true });
  };

  onExportReport = async file_code => {
    if (this.isExportingFlag) {
      return;
    }
    this.isExportingFlag = true;
    const {
      fieldId: field_id,
      isDetailKYOpen,
      kyReportId,
      selectedList,
    } = this.state;
    const ky_report_ids = isDetailKYOpen ? [kyReportId] : selectedList;
    const param = {
      file_code,
      field_id,
      ky_report_ids,
      report_code: 206,
    };
    const reportName = ReportNames.Cr139GenchiKyReport;
    const response = await KYReportsService.exportReportCr139(param);
    if (_.get(response, 'result')) {
      const { get_url, head_url } = response.presigned_url;
      const responseS3AWS = await PrintService.getHeaderReponseURL(head_url);
      if (responseS3AWS.status !== STATUS_CODE.ok) {
        return;
      }
      const fileName = PrintService.makeReportFileName(reportName, file_code);
      this.setState({
        exportResultDialog: {
          isExcel: file_code === FILE_CODE.EXCEL,
          url: get_url,
          fileName,
        },
        isShowChooseExportTypeDialog: false,
      });
    } else {
      if (_.get(response, 'message') === messageUtility.getMessage('E-001-470')) {
        _dialogLoader.show(CancelAndConfirmDialog, {
          title: messageUtility.getMessage('E-001-402'),
          message: messageUtility.getMessage('E-001-470'),
          confirmButtonText: messageUtility.getMessage('I-000-180'),
          cancelButtonText: messageUtility.getMessage('I-000-017'),
          onCancel: () => {
            _dialogLoader.close();
          },
          onConfirm: () => {
            _dialogLoader.close();
            this.needReloadData = true;
            this.handleCloseDetailKY();
          },
        });
      }
      this.setState({
        isShowChooseExportTypeDialog: false,
      });
    }
    this.isExportingFlag = false;
  };

  render() {
    const {
      data,
      isDetailKYOpen,
      kyReportData,
      selectedList,
      isLoading,
      total,
      isShowConfirmDialog,
      isDetailSearchFormOpen,
      isCheckedAll,
      isShowChooseExportTypeDialog,
      exportResultDialog,
      warning_threshold,
      keyRerenderSearchDetail,
    } = this.state;
    const isSelectEmpty = _.isEmpty(selectedList);
    return (
      <Fragment>
        {isDetailKYOpen ? (
          <DetailKYReport
            kyReportData={kyReportData}
            onClose={this.events.detailKY.handleCloseDetailKY}
            onUpdateStatus={this.events.detailKY.handleUpdateStatus}
            performNavigate={this.performNavigate}
            hasNavigate={_.size(data) > 1}
            onClickExportReport={this.handleClickExportReport}
            warning_threshold={warning_threshold}
          />
        ) : (
          <div className='main'>
            <Helmet>
              <title>{HEADER_CONSTANTS.conference} - 現地KY一覧</title>
            </Helmet>
            <ConferencePageHeader
              title='現地KY'
              rightComponent={
                <Box display='flex' alignItems='center' mt='4px' mr='8px'>
                  <button
                    className='btn-icon--sm'
                    onClick={() =>
                      KYReportsService.downloadTemplate(this.state.fieldId)
                    }
                  >
                    <i
                      className='i-download-manual i-2_4x'
                      aria-hidden='true'
                    />
                  </button>
                </Box>
              }
            />
            <div className='main__body list-ky'>
              <Box sx={{ fontSize: '14px' }} className='search-form'>
                <Box>
                  <KyReportSearchForm
                    searchButtonRef={this.searchButtonRef}
                    state={this.state}
                    callbacks={this.events.searchForm}
                    clearFlag={this.clearFlag}
                  />
                </Box>
                <Box
                  className='list-ky__search-form'
                  sx={{
                    height: '52px',
                    padding: '12px 16px',
                    display: 'flex',
                    justifyContent: 'space-between',
                  }}
                >
                  <button
                    className={`list-ky__button-confirm btn--effective--filled ${
                      isSelectEmpty ? 'btn--disabled' : ''
                    }`}
                    onClick={this.events.confirmDialog.open}
                    disabled={isSelectEmpty}
                  >
                    一括確認
                  </button>
                  <button
                    className={`btn-icon--sm ${
                      isSelectEmpty ? 'disabled' : ''
                    }`}
                    onClick={this.handleClickExportReport}
                    disabled={isSelectEmpty}
                  >
                    <i
                      className={`i-print-report${
                        isSelectEmpty ? '-inactive' : ''
                      } i-2x`}
                      aria-hidden='true'
                    />
                  </button>
                </Box>
              </Box>
              <KYReportTable
                callbacks={this.events}
                data={data}
                selectedList={selectedList}
                handleClickRowKY={this.events.table.clickRowKY}
                isLoading={isLoading}
                total={total}
                isCheckedAll={isCheckedAll}
              />
              {isShowConfirmDialog && (
                <MultiConfirmKYReportDialog
                  selectedCount={_.size(this.state.selectedList)}
                  callback={this.events.confirmDialog}
                />
              )}
              <Confirmation
                visible={isDetailSearchFormOpen}
                title={messageUtility.getMessage('I-000-268')}
                message={
                  <KyReportSearchFormDetail
                    key={keyRerenderSearchDetail}
                    state={this.state}
                    callbacks={this.events.searchForm}
                  />
                }
                confirmButtonText={messageUtility.getMessage('I-000-164-09')}
                cancelButtonText={messageUtility.getMessage('I-000-017')}
                onConfirm={this.events.searchForm.searchExecutionDetail}
                onCancel={this.events.searchForm.closeDetail}
                effectiveButtonClassName='btn--stay'
                rootClassName='search-form-detail-dialog'
              />
            </div>
          </div>
        )}
        {isShowChooseExportTypeDialog && (
          <ChooseExportTypeDialog
            onCancel={() =>
              this.setState({ isShowChooseExportTypeDialog: false })
            }
            onConfirm={this.onExportReport}
          />
        )}
        <Information
          title='出力完了'
          visible={!_.isEmpty(exportResultDialog)}
          message={
            <div>
              <p>
                出力が完了しました。
                <a
                  className='clickable-text'
                  href={exportResultDialog.url}
                  target='_blank'
                  rel='noreferrer noopener'
                  onClick={event => {
                    if (exportResultDialog.isExcel) {
                      // excelファイルの場合は、リダイレクトが発生しないように、強制的にダウンロードさせる
                      event.preventDefault();
                      PrintUtility.downloadFilePresignedUrl(
                        exportResultDialog.url,
                        exportResultDialog.fileName
                      );
                    }
                  }}
                >
                  こちら
                </a>
                のリンクと下記QRコードからダウンロード可能です。
              </p>
              <Stack mt='16px' alignItems='center'>
                <QRCodeSVG
                  value={exportResultDialog.url}
                  size={400} // Size of the QR code
                  level='L' // Error correction level (L, M, Q, H)
                />
              </Stack>
              <Box
                sx={{
                  marginTop: '16px',
                  display: 'flex',
                  justifyContent: 'flex-end',
                }}
              >
                ※QRコードは(株)デンソーウェーブの登録商標です。
              </Box>
            </div>
          }
          rootClassName='dialog--wide'
          multilineText={true}
          buttonText={messageUtility.getMessage('I-000-017')}
          onClose={() => this.setState({ exportResultDialog: {} })}
        />
      </Fragment>
    );
  }
}

const KYReportTable = ({
  callbacks,
  data,
  selectedList,
  handleClickRowKY,
  isLoading,
  total,
  isCheckedAll,
}) => {
  const isChecked = (id, selectedList) => _.includes(selectedList, id);

  return (
    <React.Fragment>
      <div
        className='list-ky__table'
        id='scroll-parent-list-ky'
      >
        <table className='table'>
          <thead>
            <tr className='table__label'>
              <td className='value-table'>
                <div className='btn-checkbox'>
                  <label>
                    <input
                      type='checkbox'
                      checked={isCheckedAll}
                      onClick={e => {
                        callbacks.table.checkOrUncheckAll(e);
                        e.stopPropagation();
                      }}
                    />
                    <i className='i-square-checkbox i-2_4x' />
                  </label>
                </div>
              </td>
              <td className='value-table value-table--table__label'>
                <div className='value-table__label'>
                  {TABLE_TITLE.WORK_DATE}
                </div>
              </td>
              <td className='value-table value-table--table__label'>
                <div className='value-table__label'>{TABLE_TITLE.STATUS}</div>
              </td>
              <td className='value-table value-table--table__label'>
                <div className='value-table__label'>
                  {TABLE_TITLE.COMPANY_NAME_1}
                </div>
              </td>
              <td className='value-table value-table--table__label'>
                <div className='value-table__label'>
                  {TABLE_TITLE.JOB_DESCRIPTION}
                </div>
              </td>
              <td className='value-table value-table--table__label'>
                <div className='value-table__label'>
                  {TABLE_TITLE.MANAGER_USER_NAME}
                </div>
              </td>
              <td className='value-table value-table--table__label'>
                <div className='value-table__label'>
                  {TABLE_TITLE.REVIEW_CONTRACTOR_USER_NAME}
                </div>
              </td>
            </tr>
          </thead>
          <tbody>
            <KYReportTableBodyRow
              data={data}
              callbacks={callbacks}
              selectedList={selectedList}
              handleClickRowKY={handleClickRowKY}
              isChecked={isChecked}
            />
          </tbody>
        </table>
        <InfinityScrollLoad
          targetId='scroll-parent-list-ky'
          total={total}
          isLoading={isLoading}
          callback={callbacks.table.loadMore}
          no_data_message={messageUtility.getMessage('I-000-005')}
        />
      </div>
    </React.Fragment>
  );
};

const KYReportTableBodyRow = ({
  data,
  callbacks,
  selectedList,
  handleClickRowKY,
  isChecked,
}) => {
  return _.map(data, (item, index) => {
    const managerUserNames = filterNotEmptyValues(item.manager_user_names);
    return (
      <tr
        key={`table__item-${index}`}
        className='row-table table__item'
        onClick={() => handleClickRowKY(item.id)}
      >
        <td className='row-table--item column-checkbox'>
          <div className='btn-checkbox' onClick={e => e.stopPropagation()}>
            <label>
              <input
                type='checkbox'
                checked={isChecked(item.id, selectedList, item.status)}
                onClick={e => callbacks.table.checkOrUncheckRow(e, item.id)}
              />
              <i className='i-square-checkbox i-2_4x' />
            </label>
          </div>
        </td>
        <td className='row-table--item column-work-date'>
          {moment(item.work_date).format('MM/DD')}
        </td>
        <td className='row-table--item column-status'>
          {getStatusLabel(item.status)}
        </td>
        <td className='row-table--item column-company_name_1'>
          <TooltipDisplay
            disable={_.isEmpty(_.toString(item.company_name_1).trim())}
            html={
              <div className='data-table__tooltip'>{item.company_name_1}</div>
            }
          >
            <div className='row-table--item label-description'>
              {_.toString(item.company_name_1).trim() || JAPANESE_EMPTY_STRING}
            </div>
          </TooltipDisplay>
        </td>
        <td className='row-table--item column-job-description'>
          <JobNameAndWorkContentTableCell
            job_names={item.job_names}
            work_contents={item.work_contents}
          />
        </td>
        <td className='row-table--item column-manager-user-name'>
          <TooltipDisplay
            disable={_.isEmpty(managerUserNames)}
            html={
              <div className='data-table__tooltip'>
                {managerUserNames.join(', ')}
              </div>
            }
          >
            <div
              className={`row-table--item label-description multi-line-ellipsis ${
                _.size(managerUserNames) > 1 ? 'flex' : ''
              }`}
            >
              <TruncatedTextConcatWithSuffix listNames={managerUserNames} />
            </div>
          </TooltipDisplay>
        </td>
        <td className='row-table--item column-review-contractor-user-name'>
          <TooltipDisplay
            disable={_.isEmpty(
              _.toString(item.review_contractor_user_name).trim()
            )}
            html={
              <div className='data-table__tooltip'>
                {item.review_contractor_user_name}
              </div>
            }
          >
            <div className='row-table--item label-description multi-line-ellipsis'>
              {_.toString(item.review_contractor_user_name).trim() ||
                JAPANESE_EMPTY_STRING}
            </div>
          </TooltipDisplay>
        </td>
      </tr>
    );
  });
};

const TooltipDisplay = props => {
  return (
    <Tippy
      duration={10}
      distance={24}
      arrowType='sharp'
      delay={[500, 0]}
      placement='bottom'
      followCursor={true}
      {...props}
    />
  );
};

const JobNameAndWorkContentTableCell = ({ job_names, work_contents }) => {
  const jobNames = filterNotEmptyValues(job_names);
  const workContents = filterNotEmptyValues(work_contents);
  return (
    <TooltipDisplay
      disable={_.isEmpty(jobNames) && _.isEmpty(workContents)}
      html={
        <div>
          <div className='data-table__tooltip'>{jobNames.join(', ')}</div>
          <div className='data-table__tooltip'>/{workContents.join(', ')}</div>
        </div>
      }
    >
      <div>
        <div
          className={`row-table--item label-description ${
            _.size(jobNames) > 1 ? 'flex' : ''
          }`}
        >
          {dataProcessing(jobNames)}
        </div>
        <div
          className={`row-table--item label-description ${
            _.size(workContents) > 1 ? 'flex' : ''
          }`}
        >
          /{dataProcessing(workContents)}
        </div>
      </div>
    </TooltipDisplay>
  );
};

const MultiConfirmKYReportDialog = ({ selectedCount, callback }) => {
  const [comment, setComment] = useState('');
  return (
    <Confirmation
      visible={true}
      title='一括確認'
      message={
        <div>
          <Box mb='16px'>{selectedCount}件のKYを一括で確認します。</Box>
          <Stack direction='row' spacing='8px'>
            <span className='label'>コメント</span>
            <textarea
              className='multi-confirm-ky-report-dialog__comment-area'
              value={comment}
              onChange={e => setComment(e.target.value)}
              maxLength={255}
            />
          </Stack>
        </div>
      }
      confirmButtonText={messageUtility.getMessage('E-000-005-01')}
      cancelButtonText={messageUtility.getMessage('I-000-017')}
      onConfirm={() => callback.submit(comment)}
      onCancel={callback.close}
      rootClassName='multi-confirm-ky-report-dialog'
    />
  );
};

const ChooseExportTypeDialog = ({ onCancel, onConfirm }) => {
  const [fileCode, setFileCode] = useState(null);
  return (
    <Confirmation
      visible={true}
      title='現地KYの出力'
      message={
        <Stack sx={{ lineHeight: '1.5' }} spacing='8px'>
          <div>選択したファイル形式で出力されます。</div>
          <Box>
            <Grid container spacing='8px'>
              <Grid item xs={6}>
                <label className='radio'>
                  <input
                    type='radio'
                    value={FILE_CODE.EXCEL}
                    checked={fileCode === FILE_CODE.EXCEL}
                    onChange={() => setFileCode(FILE_CODE.EXCEL)}
                  />
                  <i className='i-2x' />
                  <span>Excel形式で出力</span>
                </label>
              </Grid>
              <Grid item xs={6}>
                <label className='radio'>
                  <input
                    type='radio'
                    value={FILE_CODE.PDF}
                    checked={fileCode === FILE_CODE.PDF}
                    onChange={() => setFileCode(FILE_CODE.PDF)}
                  />
                  <i className='i-2x' />
                  <span>PDF形式で出力</span>
                </label>
              </Grid>
            </Grid>
          </Box>
        </Stack>
      }
      confirmButtonText='出力'
      cancelButtonText={messageUtility.getMessage('I-000-017')}
      disabledConfirmButton={_.isNil(fileCode)}
      onConfirm={() => onConfirm(fileCode)}
      onCancel={onCancel}
      rootClassName='ky-choose-report-type-dialog'
      effectiveButtonClassName='btn--effective--filled'
    />
  );
};

const filterNotEmptyValues = values => {
  return _.chain(values)
    .map(value => (_.isString(value) ? value.trim() : ''))
    .filter(value => value !== '')
    .value();
};

/**
 * @description 配列に空の値・重複値を削除する.
 * @param {Array} arr - 値リスト.
 */
const dataProcessing = arr => {
  const uniqueValidItems = _.uniq(arr);

  if (_.isEmpty(uniqueValidItems)) {
    return JAPANESE_EMPTY_STRING;
  } else if (_.size(uniqueValidItems) === 1) {
    return uniqueValidItems[0];
  } else {
    return (
      <Fragment>
        <span className='row-table--item label-description'>
          {uniqueValidItems[0]}
        </span>
        <span className='multi-name-label'>、ほか</span>
      </Fragment>
    );
  }
};

const TruncatedTextConcatWithSuffix = ({ listNames }) => {
  const uniqueValidItems = _.uniq(listNames);

  if (_.isEmpty(uniqueValidItems)) {
    return JAPANESE_EMPTY_STRING;
  } else if (_.size(uniqueValidItems) === 1) {
    return uniqueValidItems[0];
  } else {
    const wrapperRef = useRef(null);
    const nameRef = useRef(null);
    const nameDisplay = uniqueValidItems[0];
    const [wrapperWidth, setWrapperWidth] = useState(0);
    useEffect(() => {
      const currentWrapper = wrapperRef.current;
      if (!currentWrapper) {
        return;
      }
      const resizeObserver = new window.ResizeObserver(entries => {
        for (let entry of entries) {
          if (entry.target === currentWrapper) {
            setWrapperWidth(entry.contentRect.width);
          }
        }
      });
      resizeObserver.observe(currentWrapper);

      return () => {
        resizeObserver.unobserve(currentWrapper);
        resizeObserver.disconnect();
      };
    }, []);
    useEffect(() => {
      if (wrapperWidth > 0) {
        truncateTextNameConcatSuffix(
          nameDisplay,
          wrapperRef.current,
          nameRef.current
        );
      }
    }, [wrapperWidth, nameDisplay]);
    return (
      <div ref={wrapperRef}>
        <span
          className='row-table--item label-description label-pre-line'
          ref={nameRef}
        >
          {nameDisplay}
        </span>
        <span className='multi-name-label'>、ほか</span>
      </div>
    );
  }
};

/**
 * @description ステータスに応じたラベルを返す.
 * @param {number} status 現地KYのステータス.
 */
const getStatusLabel = status => {
  switch (status) {
    case KY_STATUS_CONFIG.CONFIRMING:
      return <span className='list-ky__status-waiting-confirm'>未確認</span>;
    case KY_STATUS_CONFIG.REJECT:
      return <span className='list-ky__status-reject'>差戻し</span>;
    default:
      return <span className='list-ky__status-approval'>確認済</span>;
  }
};



// WEBPACK FOOTER //
// ./src/pages/FieldListKY.jsx